import { createContext, useMemo } from "react";
import type { OneRepMaxEstimate } from "../../useAthleteProfilingChartAnnotations";

export interface ProfilingOneRepMaxEstimatesType {
  /** The 1RM estimates drawn on the profiling chart, one per side (and per variant of a unilateral profile). */
  oneRepMaxEstimates: OneRepMaxEstimate[];
}

export const ProfilingOneRepMaxEstimatesContext = createContext<ProfilingOneRepMaxEstimatesType | undefined>(undefined);
ProfilingOneRepMaxEstimatesContext.displayName = "ProfilingOneRepMaxEstimatesContext";

interface ProfilingOneRepMaxEstimatesProviderProps {
  children?: React.ReactNode;
  oneRepMaxEstimates: OneRepMaxEstimate[];
}

function ProfilingOneRepMaxEstimatesProvider(props: ProfilingOneRepMaxEstimatesProviderProps) {
  const contextValue: ProfilingOneRepMaxEstimatesType = useMemo(
    () => ({ oneRepMaxEstimates: props.oneRepMaxEstimates }),
    [props.oneRepMaxEstimates]
  );

  return (
    <ProfilingOneRepMaxEstimatesContext.Provider value={contextValue}>
      {props.children}
    </ProfilingOneRepMaxEstimatesContext.Provider>
  );
}

export default ProfilingOneRepMaxEstimatesProvider;
